import { gql } from '@apollo/client';

export const DELETE_CASE = gql`
  mutation DeleteCase($ids: [String!]!) {
    deleteCase(ids: $ids) {
      success
    }
  }
`;
